import React, { Component } from 'react';

import PartyInput from '../lib/PartyInput';
import AddressInput from '../lib/AddressInput';
import ErrorMessage from '../lib/ErrorMessage';

import geocode from '../lib/geocoding';
import districtLocator from '../lib/district-locator';
import { PARTIES } from '../lib/lookup-tables';

import '../../scss/Home.scss';

const PARTY_MAP = {
  dem: 'D',
  rep: 'R',
  grn: 'G'
};

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      party: props.party,
      address: props.address
    };
  }
  
  addressToDistrict(address) {
    this.setState({error: null, address});

    if (!address) {
      return this.setState({error: {message: 'Please enter a New York City address.'}});
    }

    geocode(address)
      .then(this.coordsToDistrict.bind(this))
      .catch(({error}) => this.setState({ error }) );
  }
  
  coordsToDistrict(location) {
    let { districts } = this.props;
    let { party } = this.state;
    let { address } = location;
    
    this.setState({ address });

    if (!party) {
      return this.setState({error: {message: 'Please select a political party.'}});
    }
    let district = districtLocator(location, districts);
    if (!district) {
      return this.setState({error: {message: 'Please enter a New York City address.'}});
    }
    
    if (window.dataLayer) {
      window.dataLayer.push({
        '2017NycVoterGuide_district': district,
        '2017NycVoterGuide_party': PARTIES[party],
        '2017NycVoterGuide_address': address,
        event: '2017NycVoterGuide_lookup-district'
      });
    }
    
    this.props.route({
      route: 'district',
      district,
      party,
      address,
      isBronx: location.isBronx,
      isBrooklyn: location.isBrooklyn
    });
  }
  
  render() {
    return (
      <div className="Home">
        <div className="Home__body">
          <h1 className="Home__headline">NYC 2017 Primary Voter Guide</h1> 
          <h3 className="Home__select">Select Your Party</h3>
          
          <div className="Home__inputs">
          {Object.keys(PARTY_MAP).map(party => {
            return <PartyInput
                    checked={PARTY_MAP[party] === this.state.party}
                    key={party}
                    onChange={p => this.setState({party: PARTY_MAP[p]})}
                    party={party} />;
          })}
          </div>
          
          <h3 className="Home__subhead">Enter Your Address</h3>
          <AddressInput onSubmit={this.addressToDistrict.bind(this)} address={this.state.address} />
          <a href="http://www.wnyc.org/privacy" target="_blank" rel="noopener noreferrer" className="Home__note">
            Privacy Policy
          </a>
          
          {this.state.error && <ErrorMessage error={this.state.error} onClick={this.coordsToDistrict.bind(this)}/>}
        </div>
        
        <div className="Home__races-to-watch">
          <button onClick={() => this.props.route({route: 'watch'})}>Races to watch</button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/Home.js